export const FetchAppInfoBridge = (
  error,
  response,
  context,
  data
) => {
  //1. If there is an error while fetch token, handle it gracefully
  if (error) {
    return;
  }

  //2. Fetch the values from the callback data and assign the response values.
  window.appInfoMeta = data;
};

/*AppInfo Meta -
  1. hasFaqLoggedOut - Did faq successfully logout or not so that there is a fresh session on click of view tickets
 */
